import { NavigationService, RegisterRouteOptions, WebNavigateOptions } from "./NavigationService";
import { navigate, replaceNavigate } from "@my-dld/utils/StoreUtils";

export default abstract class NavigationServiceBase implements NavigationService {
	navigate( path: string, options?: WebNavigateOptions ): void {
		navigate( path, options?.query, options?.state );
	}

	registerRoute( options: RegisterRouteOptions ): void {
		throw new Error( "Not implemented , platform should implement this" );
	}

	replaceNavigate( path: string, options: WebNavigateOptions | undefined ): void {
		replaceNavigate( path, options?.query, options?.state );
	}
}
